import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/Cards";

const DOW = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];
const TYPE_COLOR = { "Yıllık": "bg-primary/15 text-primary", "Hastalık": "bg-rose-500/15 text-rose-400", "Ücretsiz": "bg-sky-400/15 text-sky-400", "Mazeret": "bg-amber-400/15 text-amber-400" };

export default function LeaveCalendar({ refreshKey }) {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/staff-leaves/calendar", { params: { month } }).then((r) => setData(r.data)); }, [month, refreshKey]);

  const shift = (n) => {
    const [y, m] = month.split("-").map(Number);
    const d = new Date(y, m - 1 + n, 1);
    setMonth(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
  };
  const [y, m] = month.split("-").map(Number);
  const first = new Date(y, m - 1, 1);
  const daysInMonth = new Date(y, m, 0).getDate();
  const offset = (first.getDay() + 6) % 7;
  const cells = [...Array(offset).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
  const label = first.toLocaleDateString("tr-TR", { month: "long", year: "numeric" });

  return (
    <Card className="p-5" data-testid="leave-calendar">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-lg font-semibold flex items-center gap-2"><CalendarDays className="h-5 w-5 text-sky-400" /> İzin Takvimi</h3>
        <div className="flex items-center gap-2">
          <button onClick={() => shift(-1)} data-testid="leave-cal-prev" className="h-8 w-8 rounded-lg border border-border flex items-center justify-center hover:bg-accent"><ChevronLeft className="h-4 w-4" /></button>
          <span className="text-sm font-medium capitalize min-w-[130px] text-center" data-testid="leave-cal-month">{label}</span>
          <button onClick={() => shift(1)} data-testid="leave-cal-next" className="h-8 w-8 rounded-lg border border-border flex items-center justify-center hover:bg-accent"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      {data?.conflicts?.length > 0 && (
        <div className="mb-3 text-xs text-rose-400 font-medium" data-testid="leave-cal-conflicts">⚠ {data.conflicts.length} günde birden fazla personel aynı anda izinli</div>
      )}
      <div className="grid grid-cols-7 gap-1 text-[10px] uppercase tracking-wider text-muted-foreground mb-1">{DOW.map((d) => <div key={d} className="text-center py-1">{d}</div>)}</div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((day, i) => {
          if (!day) return <div key={`e${i}`} />;
          const key = `${month}-${String(day).padStart(2, "0")}`;
          const items = data?.days?.[key] || [];
          const conflict = items.length >= 2;
          return (
            <div key={key} data-testid={`leave-cal-day-${key}`}
              className={`min-h-[64px] rounded-lg border p-1 text-xs ${conflict ? "border-rose-500/60 bg-rose-500/10" : items.length ? "border-border bg-muted/30" : "border-border/40"}`}>
              <div className={`font-mono text-[11px] ${conflict ? "text-rose-400 font-bold" : "text-muted-foreground"}`}>{day}</div>
              <div className="space-y-0.5 mt-0.5">
                {items.slice(0, 3).map((it) => (
                  <div key={it.leave_id} className={`truncate rounded px-1 py-0.5 text-[10px] ${TYPE_COLOR[it.type] || "bg-muted"}`} title={`${it.name} · ${it.type}`}>{it.name.split(" ")[0]}</div>
                ))}
                {items.length > 3 && <div className="text-[10px] text-muted-foreground">+{items.length - 3}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
